// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.totalStatisticsContainer__lJUDN {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 25px;
  height: 45px;
  box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
}

.totalStatisticsLeftContainer__iWFpE {
  display: flex;
  gap: 50px;
}
@media (max-width: 1550px) {
  .totalStatisticsLeftContainer__iWFpE {
    gap: 25px;
  }
}

.totalStatisticsContainerTitle__kowkq {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
}
@media (max-width: 1550px) {
  .totalStatisticsContainerTitle__kowkq {
    font-size: 10px;
  }
}

.totalStatisticsValues__flKBq {
  display: flex;
  gap: 40px;
  color: var(--legend-for-header-text);
}
@media (max-width: 1550px) {
  .totalStatisticsValues__flKBq {
    gap: 15px;
  }
}

.totalStatisticsStat__i7YEv {
  display: flex;
  gap: 10px;
}

.totalStatisticsStatCount__d8Rxx {
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
  color: var(--legend-for-header-text);
}
@media (max-width: 1550px) {
  .totalStatisticsStatCount__d8Rxx {
    font-size: 10px;
  }
}

.totalStatisticsStatLabel__b9g2f {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
}
@media (max-width: 1550px) {
  .totalStatisticsStatLabel__b9g2f {
    font-size: 10px;
  }
}

.arrowIcon__URW7S {
  transition: all 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
  transform: rotate(90deg);
  margin-left: 5px;
  cursor: pointer;
}
.arrowIcon__URW7S path {
  stroke: var(--segments-chips-toggle-text-active);
}
.arrowIcon__URW7S:focus {
  outline: none;
}

.openedArrowIcon__ZYAx8 {
  transform: rotate(-90deg);
}

.hideTotalStatisticTable__D5fWO {
  display: none;
}

.totalStatisticsTableWrapper__rgh9m {
  width: 100%;
  max-width: 100%;
  max-height: calc(100vh - 295px);
  overflow: auto;
  box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.0509803922), 0px 0px 1px 0px rgba(12, 26, 75, 0.2392156863);
}
.totalStatisticsTableWrapper__rgh9m::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.totalStatisticsTableWrapper__rgh9m::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.totalStatisticsTableWrapper__rgh9m::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.totalStatisticsTableWrapper__rgh9m::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.totalStatisticsTable__IVVS3 {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.totalStatisticsTable__IVVS3 th {
  font-size: 11px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 16px 25px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-align: right;
}
@media (max-width: 850px) {
  .totalStatisticsTable__IVVS3 th {
    padding: 6px 15px;
    font-size: 9px;
  }
}
.totalStatisticsTable__IVVS3 td {
  padding: 17.5px 25px;
  color: var(--tables-primary-row-text-main);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  font-size: 14px;
  text-align: right;
}
@media (max-width: 1550px) {
  .totalStatisticsTable__IVVS3 td {
    font-size: 12px;
  }
}
.totalStatisticsTable__IVVS3 .columnLeft__uIMm2 {
  text-align: left;
}

.totalStatisticsBodyRow__HUUqA:hover {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-hover);
  box-shadow: inset 0px -1px 0px #edf2f7;
}

.totalStatisticsTableSortIcon__m4o9l {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}

.skeletonText__BGmto {
  height: 14px;
}

.tooltipSizeMedium__rd4An {
  max-width: 450px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SiteEngagement/components/TableTotalStatistics/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,2FACE;AA1EJ;;AA8EA;EACE,aAAA;EACA,SAAA;AA3EF;AA6EE;EAJF;IAKI,SAAA;EA1EF;AACF;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;AA1EF;AA4EE;EAPF;IAQI,eAAA;EAzEF;AACF;;AA4EA;EACE,aAAA;EACA,SAAA;EACA,oCAAA;AAzEF;AA2EE;EALF;IAMI,SAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,SAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AAxEF;AA0EE;EANF;IAOI,eAAA;EAvEF;AACF;;AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;AAvEF;AAyEE;EAPF;IAQI,eAAA;EAtEF;AACF;;AAyEA;EACE,wDAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;AAtEF;AAwEE;EACE,gDAAA;AAtEJ;AAyEE;EACE,aAAA;AAvEJ;;AA2EA;EACE,yBAAA;AAxEF;;AA2EA;EACE,aAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,2GACE;AAzEJ;AA1EE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA4EJ;AAzEE;EACE,+BAAA;EACA,kBAAA;AA2EJ;AAxEE;EACE,8BAAA;EACA,kBAAA;AA0EJ;AAvEE;EACE,gBAAA;EACA,kBAAA;AAyEJ;;AA8DA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AA3DF;AA6DE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mDAAA;EACA,uCAAA;EACA,iBAAA;AA3DJ;AA6DI;EAXF;IAYI,iBAAA;IACA,cAAA;EA1DJ;AACF;AA6DE;EACE,oBAAA;EACA,0CAAA;EACA,yDAAA;EACA,qDAAA;EACA,eAAA;EACA,iBAAA;AA3DJ;AA6DI;EARF;IASI,eAAA;EA1DJ;AACF;AA6DE;EACE,gBAAA;AA3DJ;;AAgEE;EACE,yDAAA;EACA,mDAAA;EACA,sCAAA;AA7DJ;;AAiEA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AA9DF;;AAiEA;EACE,YAAA;AA9DF;;AAiEA;EACE,gBAAA;AA9DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.totalStatisticsContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 25px;\n  height: 45px;\n  box-shadow:\n    0px 0px 1px 0px rgba(12, 26, 75, 0.24),\n    0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n}\n\n.totalStatisticsLeftContainer {\n  display: flex;\n  gap: 50px;\n\n  @media (max-width: 1550px) {\n    gap: 25px;\n  }\n}\n\n.totalStatisticsContainerTitle {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n\n  @media (max-width: 1550px) {\n    font-size: 10px;\n  }\n}\n\n.totalStatisticsValues {\n  display: flex;\n  gap: 40px;\n  color: var(--legend-for-header-text);\n\n  @media (max-width: 1550px) {\n    gap: 15px;\n  }\n}\n\n.totalStatisticsStat {\n  display: flex;\n  gap: 10px;\n}\n\n.totalStatisticsStatCount {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 12px;\n  color: var(--legend-for-header-text);\n\n  @media (max-width: 1550px) {\n    font-size: 10px;\n  }\n}\n\n.totalStatisticsStatLabel {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n\n  @media (max-width: 1550px) {\n    font-size: 10px;\n  }\n}\n\n.arrowIcon {\n  transition: all 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);\n  transform: rotate(90deg);\n  margin-left: 5px;\n  cursor: pointer;\n\n  path {\n    stroke: var(--segments-chips-toggle-text-active);\n  }\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.openedArrowIcon {\n  transform: rotate(-90deg);\n}\n\n.hideTotalStatisticTable {\n  display: none;\n}\n\n.totalStatisticsTableWrapper {\n  width: 100%;\n  max-width: 100%;\n  max-height: calc(100vh - 295px);\n  overflow: auto;\n  box-shadow:\n    0px 3px 8px -1px #3232470d,\n    0px 0px 1px 0px #0c1a4b3d;\n\n  @include scrollBar;\n}\n\n.totalStatisticsTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n\n  th {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 12px;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 16px 25px;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-align: right;\n\n    @media (max-width: 850px) {\n      padding: 6px 15px;\n      font-size: 9px;\n    }\n  }\n\n  td {\n    padding: 17.5px 25px;\n    color: var(--tables-primary-row-text-main);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-default);\n    font-size: 14px;\n    text-align: right;\n\n    @media (max-width: 1550px) {\n      font-size: 12px;\n    }\n  }\n\n  .columnLeft {\n    text-align: left;\n  }\n}\n\n.totalStatisticsBodyRow {\n  &:hover {\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-hover);\n    box-shadow: inset 0px -1px 0px #edf2f7;\n  }\n}\n\n.totalStatisticsTableSortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n}\n\n.skeletonText {\n  height: 14px;\n}\n\n.tooltipSizeMedium {\n  max-width: 450px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"totalStatisticsContainer": `totalStatisticsContainer__lJUDN`,
	"totalStatisticsLeftContainer": `totalStatisticsLeftContainer__iWFpE`,
	"totalStatisticsContainerTitle": `totalStatisticsContainerTitle__kowkq`,
	"totalStatisticsValues": `totalStatisticsValues__flKBq`,
	"totalStatisticsStat": `totalStatisticsStat__i7YEv`,
	"totalStatisticsStatCount": `totalStatisticsStatCount__d8Rxx`,
	"totalStatisticsStatLabel": `totalStatisticsStatLabel__b9g2f`,
	"arrowIcon": `arrowIcon__URW7S`,
	"openedArrowIcon": `openedArrowIcon__ZYAx8`,
	"hideTotalStatisticTable": `hideTotalStatisticTable__D5fWO`,
	"totalStatisticsTableWrapper": `totalStatisticsTableWrapper__rgh9m`,
	"totalStatisticsTable": `totalStatisticsTable__IVVS3`,
	"columnLeft": `columnLeft__uIMm2`,
	"totalStatisticsBodyRow": `totalStatisticsBodyRow__HUUqA`,
	"totalStatisticsTableSortIcon": `totalStatisticsTableSortIcon__m4o9l`,
	"skeletonText": `skeletonText__BGmto`,
	"tooltipSizeMedium": `tooltipSizeMedium__rd4An`
};
module.exports = ___CSS_LOADER_EXPORT___;
